import clientPageRender from 'vue-compiler/clientPageRender'

(async () => { await clientPageRender() })()
